import { InjectionKey } from "vue";
import {
  ActionTree,
  createStore,
  GetterTree,
  MutationTree,
  Store,
  StoreOptions,
  useStore,
} from "vuex";
import { EDeviceTypeName } from "../types";
import {
  Device,
  DeviceHms,
  DeviceOsd,
  DeviceStatus,
  DockOsd,
  GatewayOsd,
  OSDVisible,
} from "../types/device";
import { getLayers } from "/@/api/layer";
import { LayerType } from "/@/types/mapLayer";
import { WaylineFile } from "/@/types/wayline";
import { DevicesCmdExecuteInfo } from "/@/types/device-cmd";

const initStateFunc = () => ({
  Layers: [
    {
      name: "default",
      id: "",
      is_distributed: true,
      elements: [],
      is_check: false,
      is_select: false,
      type: 1,
    },
    {
      name: "share",
      id: "",
      is_distributed: true,
      elements: [],
      is_check: false,
      is_select: false,
      type: 2,
    },
  ],
  layerBaseInfo: {} as {
    [key: string]: string;
  },
  drawVisible: false,
  coverList: [] as any,
  wsEvent: {
    mapElementCreat: {},
    mapElementUpdate: {},
    mapElementDelete: {},
  },
  deviceStatusEvent: {
    deviceOnline: {} as DeviceStatus,
    deviceOffline: {},
  },
  dockOnlineInfo: {
    data: [],
  },
  // 飞机视频变量
  phaneInfo: {
    isType: false,
  },
  // 独立人员
  userOnline: {
    data: [],
  },
  // 警情任务
  warnTask: {
    data: [],
    list: [],
  },
  // 消息推送
  drcEnter: {
    data: [],
    dockData: [], //显示被手控的人的用户名
  },
  // 正在执行的航线信息
  onWaylineInfo: {
    data: [],
  },
  // 一键起飞正在执行的任务
  manual: {
    data: [],
  },
  // 飞行姿态数据
  manualKey: {
    data: [],
  },
  // 机场空调状态 列表
  AirState: {
    data: [],
  },
  // 控制大屏 视频列表
  videoOnline: {
    data: [],
  },
  // 工地 飞行过程中途径的工地列表
  construction: {
    data: [],
    aiImg: {}, // 飞行过程中识别的ai图片
  },
  // 控制大屏 自定义 网格 数据
  girdCustom: {
    data: {},
    realData: {}, // 网格监测-实时概览数据
  },
  // mqtt 返回的布尔值，用于手控 是否可以进行下一次手控操作，true为可以进行手控操作，false不可以
  ALL_mqttFlag: true,
  // mqtt 返回的布尔值，用于焦距 是否可以进行下一次焦距操作，true为可以进行焦距操作，false不可以
  ornamentFlag: {
    num: 2,
    success: true,
  },
  markerInfo: {
    coverMap: {} as {
      [sn: string]: any;
    },
    pathMap: {} as {
      [sn: string]: any[];
    },
  },
  deviceState: {
    // remote controller, dock
    gatewayInfo: {} as {
      [sn: string]: GatewayOsd;
    },
    // drone
    deviceInfo: {} as {
      [sn: string]: DeviceOsd;
    },
    dockInfo: {} as {
      [sn: string]: DockOsd;
    },
    currentSn: "",
    currentType: -1,
  },
  osdVisible: {
    // osd 显示设备相关信息
    sn: "",
    callsign: "",
    model: "",
    visible: false,
    gateway_sn: "",
    is_dock: false,
    payloads: null,
  } as OSDVisible,
  waylineInfo: {} as WaylineFile,
  dockInfo: {} as Device,
  hmsInfo: {} as {
    [sn: string]: DeviceHms[];
  },
  // 机场指令执行状态信息
  devicesCmdExecuteInfo: {} as DevicesCmdExecuteInfo,
  mqttState: null as any, // mqtt 实例
  clientId: "", // mqtt 连接 唯一客户端id
  // 相机类型
  cameraStatus: {} as any, // 相机类型
  airListInfo: [] as any, // 第三方设备空气监测数据
  spectralList: [] as any, // 第三方设备 多光谱
  menuShrink: true, // 菜单收缩状态，true为收缩，false为展开
  activeAiModel: {} as any, // ai 选中的模型
});

export type RootStateType = ReturnType<typeof initStateFunc>;

const getters: GetterTree<RootStateType, RootStateType> = {};

const mutations: MutationTree<RootStateType> = {
  SET_LAYER_INFO(state, info) {
    state.Layers = info;
  },
  SET_PHANE_INFO(state, info) {
    //state.phaneInfo.isType = info
  },
  SET_DEVICE_INFO(state, info) {
    state.deviceState.deviceInfo[info.sn] = info.host;
    state.deviceState.currentSn = info.sn;
    state.deviceState.currentType = EDeviceTypeName.Aircraft;
  },
  SET_GATEWAY_INFO(state, info) {
    state.deviceState.gatewayInfo[info.sn] = info.host;
    state.deviceState.currentSn = info.sn;
    state.deviceState.currentType = EDeviceTypeName.Gateway;
  },
  SET_DOCK_INFO(state, info) {
    if (Object.keys(info.host).length === 0) {
      return;
    }
    if (!state.deviceState.dockInfo[info.sn]) {
      state.deviceState.dockInfo[info.sn] = {} as DockOsd;
    }
    state.deviceState.currentSn = info.sn;
    state.deviceState.currentType = EDeviceTypeName.Dock;
    const dock = state.deviceState.dockInfo[info.sn];
    if (info.host.mode_code !== undefined) {
      dock.basic_osd = info.host;
      return;
    }
    if (info.host.sdr) {
      dock.link_osd = info.host;
      return;
    }
    if (info.host.job_number !== undefined) {
      dock.work_osd = info.host;
      return;
    }
    // dock.basic_osd = info.host
  },
  SET_DRAW_VISIBLE_INFO(state, bool) {
    state.drawVisible = bool;
  },
  // 设置机场默认显示在地图上
  SET_ONLINE_VISIBLE_INFO(state, bool) {
    state.dockOnlineInfo.data = bool;
  },
  SET_MAP_ELEMENT_CREATE(state, info) {
    state.wsEvent.mapElementCreat = info;
  },
  SET_MAP_ELEMENT_UPDATE(state, info) {
    state.wsEvent.mapElementUpdate = info;
  },
  SET_MAP_ELEMENT_DELETE(state, info) {
    state.wsEvent.mapElementDelete = info;
  },
  // 独立人员
  SET_USER_ONLINE(state, info) {
    state.userOnline.data = info;
  },
  // 告警事件
  SET_WARN_EVENT(state, info) {
    state.warnTask.list = info;
  },
  // 警情任务
  SET_WARN_TASK(state, info) {
    state.warnTask.data = info;
  },
  // 消息推送
  SET_DRC_ENTER(state, info) {
    state.drcEnter.data = info;
  },
  // 消息推送1
  SET_DRC_ENTER_DOCK(state, info) {
    state.drcEnter.dockData = info;
  },
  // 正在执行的航线信息
  SET_ON_WAYLINE_INFO(state, info) {
    state.onWaylineInfo.data = info;
  },
  // 一键起飞正在执行的任务
  SET_MANUAL(state, info) {
    state.manual.data = info;
  },
  // 飞行姿态
  SET_MANUAL_key(state, info) {
    state.manualKey.data = info;
  },
  // 控制大屏数据列表
  SET_VIDEO_ONLINE(state, info) {
    state.videoOnline.data = info;
  },
  // 飞行过程中 途径的工地列表
  SET_CONSTRUCTION(state, info) {
    state.construction.data = info;
  },
  // 飞行过程中 识别的ai图片
  SET_AI_IMG(state, info) {
    state.construction.aiImg = info;
  },
  // 机场空调 列表
  SET_AIR_STATE(state, info) {
    state.AirState.data = info;
  },
  // 设置相机类型
  SET_CAMERA_STATUS(state, info) {
    state.cameraStatus[info.video_id] = info;
  },
  // 设置 第三方 设备 数据
  SET_LORA_AIRS(state, info) {
    state.airListInfo = info;
  },
  // 设置 第三方 多光谱 数据
  SET_AERO_SPOT_DATA(state, info) {
    state.spectralList = info;
  },
  // 设置菜单收缩状态
  SET_MENU_SHRINK(state, info) {
    state.menuShrink = info;
  },
  // 控制大屏 网格数据
  SET_GRID_CUSTOM(state, info) {
    state.girdCustom.data = info;
  },
  // 空气监测 网格 实时概览 数据
  SET_GRID_REALDATA(state, info) {
    state.girdCustom.realData = info;
  },
  // 手控 是否可以进行下一次手控操作，true为可以进行手控操作，false不可以
  SET_MQTT_FLAG(state, info) {
    state.ALL_mqttFlag = info;
  },
  // 焦距 是否可以进行下一次焦距操作，true为可以进行焦距操作，false不可以
  SET_ORNA_FLAG(state, info) {
    state.ornamentFlag.num = info?.num;
    state.ornamentFlag.success = info?.success;
  },
  SET_DEVICE_ONLINE(state, info) {
    state.deviceStatusEvent.deviceOnline = info;
  },
  // ai 选中的模型
  SET_CHANGE_ACTIVE_TASKS(state, info) {
    state.activeAiModel = info;
  },
  SET_DEVICE_OFFLINE(state, info) {
    state.deviceStatusEvent.deviceOffline = info;
    delete state.deviceState.gatewayInfo[info.sn];
    delete state.deviceState.deviceInfo[info.sn];
    delete state.deviceState.dockInfo[info.sn];
    delete state.hmsInfo[info.sn];
    // delete state.markerInfo.coverMap[info.sn]
    // delete state.markerInfo.pathMap[info.sn]
  },
  SET_OSD_VISIBLE_INFO(state, info) {
    state.osdVisible = info;
  },
  SET_SELECT_WAYLINE_INFO(state, info) {
    state.waylineInfo = info;
  },
  SET_SELECT_DOCK_INFO(state, info) {
    state.dockInfo = info;
  },
  SET_DEVICE_HMS_INFO(state, info) {
    const hmsList: Array<DeviceHms> = state.hmsInfo[info.sn];
    state.hmsInfo[info.sn] = info.host.concat(hmsList ?? []);
  },
  SET_DEVICES_CMD_EXECUTE_INFO(state, info) {
    // 保存设备指令ws消息推送
    if (!info.sn) {
      return;
    }
    if (state.devicesCmdExecuteInfo[info.sn]) {
      const index = state.devicesCmdExecuteInfo[info.sn].findIndex(
        (cmdExecuteInfo) => cmdExecuteInfo.biz_code === info.biz_code
      );
      if (index >= 0) {
        // 丢弃前面的消息
        if (
          state.devicesCmdExecuteInfo[info.sn][index].timestamp > info.timestamp
        ) {
          return;
        }
        state.devicesCmdExecuteInfo[info.sn][index] = info;
      } else {
        state.devicesCmdExecuteInfo[info.sn].push(info);
      }
    } else {
      state.devicesCmdExecuteInfo[info.sn] = [info];
    }
  },
  SET_MQTT_STATE(state, mqttState) {
    state.mqttState = mqttState;
  },
  SET_CLIENT_ID(state, clientId) {
    state.clientId = clientId;
  },
};

const actions: ActionTree<RootStateType, RootStateType> = {
  async getAllElement({ commit }) {
    const result = await getLayers({
      groupId: "",
      isDistributed: true,
    });
    // @ts-ignore
    commit("SET_LAYER_INFO", result.data?.list);
  },
  updateElement(
    { state },
    content: { type: "is_check" | "is_select"; id: string; bool: boolean }
  ) {
    const key = content.id.replaceAll("resource__", "");
    const type = content.type;
    const layers = state.Layers;
    const layer = layers.find((item) => item.id === key);
    if (layer) {
      layer[type] = content.bool;
    }
  },
  setLayerInfo({ state }, layers) {
    // const layers = state.Layers
    const obj: {
      [key: string]: string;
    } = {};
    layers.forEach((layer: any) => {
      if (layer.type === LayerType.Default) {
        obj.default = layer.id;
      } else {
        if (layer.type === LayerType.Share) {
          obj.share = layer.id;
        }
      }
    });
    state.layerBaseInfo = obj;
    // console.log("state.layerBaseInfo", state.layerBaseInfo);
  },
  getLayerInfo({ state }, id: string) {
    return state.layerBaseInfo[id];
  },
};

const storeOptions: StoreOptions<RootStateType> = {
  state: initStateFunc,
  getters,
  mutations,
  actions,
};

const rootStore = createStore(storeOptions);

export default rootStore;

export const storeKey: InjectionKey<Store<RootStateType>> = Symbol("");

type AllStateStoreTypes = RootStateType & {
  // moduleName: moduleType
};

export function useMyStore<T = AllStateStoreTypes>() {
  return useStore<T>(storeKey);
}
